export const TEAM_IDS = {
  ATLAS: "flGD6fmMWw2jLMlNzPBX6",

  SYNTHLABS: "synthlabs",

  OPENROUTER: "xzWAGk1zQGhBCbU0o3dX8",

  ACULIX: "Ibfq8G-pZcIug-xQLr-kj",

  ALEX_FROM_ENIGMA: "kDchzgXWgDvhPmcmkmw2t",

  // This is the team ID for the Inference.net Mainnet account for Roo Code (roo-code@inference.net).
  // This account will accrue partner payment revenue. The login credentials are stored in 1Password.
  ROO_CODE: "x8OFr8FUemOtbG3lCo-aG",

  WYND_LABS_GRASS: "YPKgZPsfzY0xr7ziHct7i",

  MY_AESTHETIC: "xIQrAwlLKymI6W9959WpH",

  SMALL_MODEL_RESEARCH_TEAM: "FaPe-oaehgOs4OG8tLQv8",

  TEST_TEAM: "test-user-id",

  PETT_AI: "6M_jEsKGBeuz_N08jXBER",

  CAL_AI: "wAFt3HMNY5auvRNrJ_v3-",

  FRANCESCO_TEAM_KUZCO_COOL: "cKJo4Egu1zrBXhjoBACJN",
  ABE_KUZCO_COOL: "tPY8lfgEG3u9W-NTOJmwo",

  ABE_INFERENCE_NET: "8cslHZCVjpMa7PjuPWYwo",

  SYSTEM_ACCOUNT: "system-status",

  AMAR_INFERENCE_NET: "0BF3lKwly5xCEYomFebT2",

  HARRY_INFERENCE_NET: "8bUYdZkpItQTKoHemSu0l",

  SHIVAM_PROFOUND_AI: "F3rllvQlTXSdVIXDfQsrT",

  TENACITY_LABS: "kcrpN1SO0C4Y0K2Wsrf2S",

  GRAVITY_ADS: "83w90fwjaa4Al6idQatXZ",

  RIZZ: "Gq4T-Jfqa0X17UqsOm7QZ",

  OLIVE: "CBbOckZncfYcR4w9j3mxX",

  // Compression team ("Comp AI"). Restricted to third-party routes for
  // Kimi K3 Fast because our hosted nvfp4 serving emits rare wrong-language
  // tokens (INF-5737); see TEAM_IDS_EXCLUDED_FROM_HOSTED_SERVING in
  // apps/llm-ops-proxy/src/routing/serverless-route-resolver.ts.
  COMP_AI: "fGY1p9ECSOFxdasGkQIMaxwOWnqxAseA",
};

export const BYPASS_INFERENCE_ANALYTICS_TEAM_IDS = [
  TEAM_IDS.ATLAS,
  TEAM_IDS.OPENROUTER,
  TEAM_IDS.ACULIX,
  TEAM_IDS.WYND_LABS_GRASS,
  TEAM_IDS.SMALL_MODEL_RESEARCH_TEAM,
  TEAM_IDS.ROO_CODE,
  TEAM_IDS.ALEX_FROM_ENIGMA,
  TEAM_IDS.PETT_AI,
  TEAM_IDS.CAL_AI,
  TEAM_IDS.SYSTEM_ACCOUNT,
  TEAM_IDS.TEST_TEAM,
  TEAM_IDS.AMAR_INFERENCE_NET,
  TEAM_IDS.HARRY_INFERENCE_NET,
  TEAM_IDS.SHIVAM_PROFOUND_AI,
  TEAM_IDS.ABE_INFERENCE_NET,
  TEAM_IDS.TENACITY_LABS,
  TEAM_IDS.GRAVITY_ADS,
  TEAM_IDS.RIZZ,
];
